module.exports = __webpack_public_path__ + "img/hero-mobile-mockup.c6f6073d.png";